//TODO: refactor - generate link components from data object`

import Box from 'components/shared/Box'
import Checkbox from 'components/shared/Checkbox'
import MultiSelect from 'components/shared/MultiSelect'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { useEffect, useState } from 'react'
import agreementData from 'translations/standalone/agreements'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { toggleAgreement, setOptionalAgreements } from 'store/order-slice'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'
import { OptionalAgreementsType } from 'store/api-slice/types'
import { FormattedMessage, useIntl } from 'react-intl'
import { CustomLink } from './styles'
import * as LINKS from 'constants/links'
import { setIsCalendarModalOpened } from 'store/unlimited-slice'
import { useApp } from 'store/steps'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'
import { isStartDateAfterEndDate } from 'helpers/dates'
import {
    PROMO_NAME_MARCH,
    PROMO_NAME_SV79,
} from 'components/shared/Promotions/constants'
import useCityBreak from 'components/common/CityBreak/utils/useCityBreak'

const Agreements = () => {
    const { isUnlimitedMode, isCreatorMode } = useApp()
    const {
        isBlackPromoForUnlimited,
        isBlackPromoForCreatorVisibleOutside,
        isBirthdayPromoForCreatorVisibleOutside,
        isBirthdayPromoForUnlimited,
        getPromotionByName,
        isMayPromotionForStudentsActive,
        isMayPromotionForWeekendsActive,
    } = usePromotions()
    const { isCityBreakApplicableForRegulations } = useCityBreak()

    const { appMode } = useAppSelector((state) => state.general)
    const { renewCardCurrentData } = useAppSelector((state) => state.unlimited)
    const { isMarchPromoMode } = useAppSelector((state) => state.selfcare)

    const [optionalsState, setOptionalsState] = useState([
        false,
        false,
        false,
        false,
        false,
        false,
    ])
    const [areAllSelected, setAreAllSelected] = useState(false)

    const [isCalendarAccepted, setIsCalendarAccepted] = useState(
        !isUnlimitedMode
    )
    const [areTermsAccepted, setAreTermsAccepted] = useState(false)

    const dispatch = useAppDispatch()
    const { isAgreementChecked } = useAppSelector((state) => state.order)
    const { getError } = useErrorMessages()
    const { formatMessage } = useIntl()

    const isRenewedMode = appMode === 'unlimited-renew'
    const isVouchersMode = appMode === 'vouchers'
    const isSelfcareMode = appMode === 'selfcare'

    const { nextEditionType } = renewCardCurrentData || {}

    const getOptionalAgreements = (optionals: boolean[]) => {
        const currentAgreements: OptionalAgreementsType[] = []

        optionals.forEach((agreement, index) => {
            if (agreement) currentAgreements.push(agreementData[index].id)
        })

        return currentAgreements
    }

    const selectAllHandler = () => {
        setAreAllSelected(!areAllSelected)

        const optionalsUpdatedCopy = optionalsState.map(
            (state) => (state = !areAllSelected)
        )
        setOptionalsState(optionalsUpdatedCopy)
        dispatch(
            setOptionalAgreements(getOptionalAgreements(optionalsUpdatedCopy))
        )
    }

    const handleOptionalsChange = (
        passedIndex: number,
        isNewValue: boolean
    ) => {
        const optionalsUpdatedCopy = optionalsState.map((value, index) =>
            passedIndex === index ? isNewValue : value
        )
        setOptionalsState(optionalsUpdatedCopy)
        dispatch(
            setOptionalAgreements(getOptionalAgreements(optionalsUpdatedCopy))
        )

        if (optionalsUpdatedCopy.every((value) => value === true))
            return setAreAllSelected(true)
        setAreAllSelected(false)
    }

    const handleShowCalendar = () => {
        dispatch(setIsCalendarModalOpened(true))
    }

    useEffect(() => {
        const isFullAgreement = isCalendarAccepted && areTermsAccepted
        dispatch(toggleAgreement(isFullAgreement))
    }, [isCalendarAccepted, areTermsAccepted])

    useEffect(() => {
        if (isAgreementChecked) dispatch(toggleAgreement(false))
    }, [])

    return (
        <Section>
            <Box gap={[32, 40]} isFullWidth>
                <Box gap={24} id="agreementsBox">
                    {!!getError('isRequitedTermsAccepted') &&
                        !isAgreementChecked && (
                            <Text variant="bodySmall" color="error">
                                {formatMessage({
                                    id: 'order.agreements.regulations_and_privacy',
                                    defaultMessage:
                                        'Zaakceptuj regulaminy oraz politykę prywatności.',
                                })}
                            </Text>
                        )}
                    {isUnlimitedMode && (
                        <Checkbox
                            isChecked={isCalendarAccepted}
                            setIsChecked={() =>
                                setIsCalendarAccepted(!isCalendarAccepted)
                            }
                            testId="payment-check-calendar-regulations"
                        >
                            <Text
                                variant="bodySmall"
                                color={
                                    getError('isRequitedTermsAccepted') &&
                                    !isCalendarAccepted
                                        ? 'error'
                                        : 'grayscale_900'
                                }
                                onClick={(event) => event.stopPropagation()}
                            >
                                <span
                                    onClick={() =>
                                        setIsCalendarAccepted(
                                            !isCalendarAccepted
                                        )
                                    }
                                >
                                    {formatMessage({
                                        id: 'order.agreements.agree_and_accept',
                                        defaultMessage:
                                            '*Zapoznałem/am się i akceptuję',
                                    })}{' '}
                                </span>

                                <CustomLink
                                    as="button"
                                    variant="bodySmallStrong"
                                    color="secondary_500"
                                    onClick={handleShowCalendar}
                                >
                                    {formatMessage({
                                        id: 'annual.calendar.agreement_title',
                                        defaultMessage:
                                            'Kalendarz świąt Suntago',
                                    })}{' '}
                                </CustomLink>
                            </Text>
                        </Checkbox>
                    )}
                    <Checkbox
                        isChecked={areTermsAccepted}
                        setIsChecked={() =>
                            setAreTermsAccepted(!areTermsAccepted)
                        }
                        testId="payment-check-obligatory-regulations"
                    >
                        <Text
                            variant="bodySmall"
                            color={
                                getError('isRequitedTermsAccepted') &&
                                !areTermsAccepted
                                    ? 'error'
                                    : 'grayscale_900'
                            }
                            onClick={(event) => event.stopPropagation()}
                        >
                            <span
                                onClick={() =>
                                    setAreTermsAccepted(!areTermsAccepted)
                                }
                            >
                                {formatMessage({
                                    id: 'order.agreements.agree_and_accept',
                                    defaultMessage:
                                        '*Zapoznałem/am się i akceptuję',
                                })}{' '}
                            </span>
                            {isVouchersMode && (
                                <CustomLink
                                    as="a"
                                    variant="bodySmallStrong"
                                    color="secondary_500"
                                    href={LINKS.VOUCHER_LINK}
                                    target="_blank"
                                >
                                    {formatMessage({
                                        id: 'order.agreements.vouchers',
                                        defaultMessage:
                                            'Regulamin zakupu i korzystania z voucherów',
                                    })}
                                    {', '}
                                </CustomLink>
                            )}
                            <CustomLink
                                as="a"
                                variant="bodySmallStrong"
                                color="secondary_500"
                                href={
                                    LINKS.SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK
                                }
                                target="_blank"
                            >
                                {formatMessage({
                                    id: 'order.agreements.tickets_online',
                                    defaultMessage:
                                        'Regulamin sprzedaży biletów online,',
                                })}{' '}
                            </CustomLink>
                            <CustomLink
                                as="a"
                                variant="bodySmallStrong"
                                color="secondary_500"
                                href={
                                    LINKS.GENERAL_REGULATIONS_OF_SUNTAGO_WATER_WORLD_LINK
                                }
                                target="_blank"
                            >
                                {formatMessage({
                                    id: 'order.agreements.water_park_suntago',
                                    defaultMessage:
                                        'Regulamin korzystania z parku wodnego Suntago,',
                                })}{' '}
                            </CustomLink>
                            {isUnlimitedMode && (
                                <>
                                    <CustomLink
                                        as="a"
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                        href={LINKS.CARD_REGULATIONS_LINK}
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: 'annual.order.cards_regulations',
                                            defaultMessage:
                                                'Regulamin kart całorocznych',
                                        })}
                                    </CustomLink>
                                    {isRenewedMode && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={LINKS.VOUCHER_LINK}
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.vouchers',
                                                    defaultMessage:
                                                        'Regulamin zakupu i korzystania z voucherów',
                                                })}
                                            </CustomLink>
                                            {', '}
                                            {nextEditionType === 'red' ? (
                                                <CustomLink
                                                    as="a"
                                                    variant="bodySmallStrong"
                                                    color="secondary_500"
                                                    href={
                                                        LINKS.UNLIMITED_2ND_RENEW_REGULATIONS_LINK
                                                    }
                                                    target="_blank"
                                                >
                                                    {formatMessage({
                                                        id: 'order.agreements.unlimited_2nd_renew',
                                                        defaultMessage:
                                                            'Zasady specjalnej oferty dla obecnych użytkowników kart Unlimited Blue',
                                                    })}
                                                </CustomLink>
                                            ) : (
                                                <CustomLink
                                                    as="a"
                                                    variant="bodySmallStrong"
                                                    color="secondary_500"
                                                    href={
                                                        LINKS.UNLIMITED_1ST_RENEW_REGULATIONS_LINK
                                                    }
                                                    target="_blank"
                                                >
                                                    {formatMessage({
                                                        id: 'order.agreements.unlimited_1st_renew',
                                                        defaultMessage:
                                                            'Zasady specjalnej oferty dla obecnych użytkowników kart',
                                                    })}
                                                </CustomLink>
                                            )}
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.UNLIMITED_RENEW_USAGE_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.unlimited_renew_usage',
                                                    defaultMessage:
                                                        'Zasady korzystania z voucherów specjalnych nabytych w ramach Specjalnej Oferty Zakupu Nowej Karty Suntago',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}
                                    {isBirthdayPromoForUnlimited && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.BIRTHDAY_PROMOTION_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.birthday_promo',
                                                    defaultMessage:
                                                        'Regulamin promocji “Piąte Urodziny Suntago”',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}
                                    {isBlackPromoForUnlimited && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.BLACK_WEEKEND_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.black_weekend',
                                                    defaultMessage:
                                                        'Regulamin promocji “Black Weekend w Suntago”',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}
                                </>
                            )}
                            {!isUnlimitedMode && (
                                <>
                                    <CustomLink
                                        as="a"
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                        href={
                                            LINKS.SUNTAGO_VILLAGE_RESERVATION_REGULATIONS_LINK
                                        }
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: 'order.agreements.reservation_suntago_village',
                                            defaultMessage:
                                                'Regulamin Sprzedaży Suntago Village,',
                                        })}{' '}
                                    </CustomLink>
                                    <CustomLink
                                        as="a"
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                        href={
                                            LINKS.SUNTAGO_VILLAGE_STAY_REGULATIONS_LINK
                                        }
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: 'order.agreements.stay_suntago_village',
                                            defaultMessage:
                                                'Regulamin Pobytu w Suntago Village',
                                        })}
                                        {!isVouchersMode ? ', ' : ''}
                                    </CustomLink>
                                    {!isVouchersMode && (
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={LINKS.VIP_ZONE_REGULATIONS}
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.vip_zone',
                                                defaultMessage:
                                                    'Regulamin strefy VIP',
                                            })}
                                        </CustomLink>
                                    )}
                                    {isBirthdayPromoForCreatorVisibleOutside && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.BIRTHDAY_PROMOTION_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.birthday_promo',
                                                    defaultMessage:
                                                        'Regulamin promocji “Piąte Urodziny Suntago”',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}

                                    {((getPromotionByName(
                                        PROMO_NAME_MARCH,
                                        'isActiveForRegulations'
                                    ) &&
                                        !isVouchersMode) ||
                                        isMarchPromoMode) && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.MARCH_PROMOTION_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.march_promo',
                                                    defaultMessage:
                                                        'Regulamin promocji “March Promo”',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}

                                    {isCityBreakApplicableForRegulations && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.CITY_BREAK_PROMOTION_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.city_break_promo',
                                                    defaultMessage:
                                                        'Zasady promocji Suntago City break',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}

                                    <>
                                        {', '}
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={
                                                LINKS.FAMILY_PACKAGE_REGULATIONS_LINK
                                            }
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.family_package',
                                                defaultMessage:
                                                    'Specjalne warunki zakupu Pakietu Rodzinnego',
                                            })}
                                        </CustomLink>
                                    </>
                                    {!isVouchersMode && (
                                        <>
                                            {', '}
                                            <CustomLink
                                                as="a"
                                                variant="bodySmallStrong"
                                                color="secondary_500"
                                                href={
                                                    LINKS.SENIOR_PACKAGE_REGULATIONS_LINK
                                                }
                                                target="_blank"
                                            >
                                                {formatMessage({
                                                    id: 'order.agreements.senior_package',
                                                    defaultMessage:
                                                        'Zasady promocji Pakiet dla Seniora',
                                                })}
                                            </CustomLink>
                                        </>
                                    )}
                                </>
                            )}
                            {isMayPromotionForStudentsActive && (
                                <>
                                    {', '}
                                    <CustomLink
                                        as="a"
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                        href={
                                            LINKS.MAY_PROMO_STUDENTS_REGULATIONS_LINK
                                        }
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: 'order.agreements.may_promotion_students',
                                            defaultMessage:
                                                'Regulamin promocji “Dla młodych do 26 roku życia”',
                                        })}
                                    </CustomLink>
                                </>
                            )}
                            {isMayPromotionForWeekendsActive && (
                                <>
                                    {', '}
                                    <CustomLink
                                        as="a"
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                        href={
                                            LINKS.MAY_PROMO_WEEKENDS_REGULATIONS_LINK
                                        }
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: 'order.agreements.may_promotion_weekends',
                                            defaultMessage:
                                                'Zasady promocji “Majowe weekendy”',
                                        })}
                                    </CustomLink>
                                </>
                            )}
                            {isCreatorMode &&
                                getPromotionByName(
                                    'Summer Sale',
                                    'isActiveForRegulations'
                                ) && (
                                    <>
                                        {', '}
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={
                                                LINKS.SUMMER_SALE_REGULATIONS_LINK
                                            }
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.summer_sale',
                                                defaultMessage:
                                                    'Regulamin promocji “Letnia Wyprzedaż”',
                                            })}
                                        </CustomLink>
                                    </>
                                )}
                            {(isCreatorMode || isSelfcareMode) &&
                                isStartDateAfterEndDate('2024-06-03') && (
                                    <>
                                        {', '}
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={
                                                LINKS.EARLY_PURCHASE_REGULATIONS_LINK
                                            }
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.early_purchase',
                                                defaultMessage:
                                                    'Regulamin promocji “Online taniej 10/20 zł”',
                                            })}
                                        </CustomLink>
                                    </>
                                )}
                            {isCreatorMode &&
                                getPromotionByName(
                                    PROMO_NAME_SV79,
                                    'isActiveForRegulations'
                                ) && (
                                    <>
                                        {', '}
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={
                                                LINKS.SV_79_PROMO_REGULATIONS_LINK
                                            }
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.sv_79_promo_regulations',
                                                defaultMessage:
                                                    'Regulamin promocji “Dwie Noce w Tropikach”',
                                            })}
                                        </CustomLink>
                                    </>
                                )}
                            {isCreatorMode &&
                                getPromotionByName(
                                    'Student Promotion 2024',
                                    'isActiveForRegulations'
                                ) && (
                                    <>
                                        {', '}
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={
                                                LINKS.STUDENT_PROMO_2024_REGULATIONS_LINK
                                            }
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.student_promo_2024_regulations',
                                                defaultMessage:
                                                    'Zasady promocji “Jesień dla młodych”',
                                            })}
                                        </CustomLink>
                                    </>
                                )}

                            {isBlackPromoForCreatorVisibleOutside &&
                                !isUnlimitedMode && (
                                    <>
                                        {', '}
                                        <CustomLink
                                            as="a"
                                            variant="bodySmallStrong"
                                            color="secondary_500"
                                            href={
                                                LINKS.BLACK_WEEKEND_REGULATIONS_LINK
                                            }
                                            target="_blank"
                                        >
                                            {formatMessage({
                                                id: 'order.agreements.black_weekend',
                                                defaultMessage:
                                                    'Regulamin promocji “Black Weekend w Suntago”',
                                            })}
                                        </CustomLink>
                                    </>
                                )}
                            {isSelfcareMode ? ', ' : ' '}
                            {!isSelfcareMode && (
                                <Text
                                    as="span"
                                    variant="bodySmallStrong"
                                    color="grayscale_900"
                                >
                                    {formatMessage({
                                        id: 'global.and',
                                        defaultMessage: 'i',
                                    })}{' '}
                                </Text>
                            )}
                            <CustomLink
                                as="a"
                                variant="bodySmallStrong"
                                color="secondary_500"
                                href={LINKS.PRIVACY_POLICY_LINK}
                                target="_blank"
                            >
                                {formatMessage({
                                    id: 'order.agreements.privacy_policy',
                                    defaultMessage: 'Politykę prywatności,',
                                })}
                            </CustomLink>
                            {isSelfcareMode && (
                                <>
                                    {' '}
                                    <Text
                                        as="span"
                                        variant="bodySmallStrong"
                                        color="grayscale_900"
                                    >
                                        {formatMessage({
                                            id: 'global.and',
                                            defaultMessage: 'i',
                                        })}{' '}
                                    </Text>
                                    <CustomLink
                                        as="a"
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                        href={LINKS.VOUCHER_LINK}
                                        target="_blank"
                                    >
                                        {formatMessage({
                                            id: 'order.agreements.vouchers',
                                            defaultMessage:
                                                'Regulamin zakupu i korzystania z voucherów',
                                        })}
                                    </CustomLink>
                                </>
                            )}
                        </Text>
                    </Checkbox>
                    <MultiSelect
                        checkBoxList={agreementData}
                        states={optionalsState}
                        setStates={handleOptionalsChange}
                        selectAllState={areAllSelected}
                        selectAllHandler={selectAllHandler}
                        selectAllLabel={formatMessage({
                            id: 'order.agreements.select_all_optionals',
                            defaultMessage: 'Akceptuję inne zgody',
                        })}
                    />
                </Box>
                <Text variant="bodyExtraSmall" color="grayscale_700">
                    <FormattedMessage
                        id="order.consent"
                        defaultMessage="Podając w formularzu zamówienia informacje o stanie zdrowia (informacja o ciąży, o niepełnosprawności) i klikając przycisk „Złóż zamówienie”, oświadczam, że zgadzam się na przetwarzanie tych danych w celu zakupu biletu ulgowego i jestem uprawniony/a do złożenia tej zgody."
                    />
                </Text>
            </Box>
        </Section>
    )
}

export default Agreements
